import React from "react";
import PropTypes from "prop-types";

import LabeledContent from "@components/LabeledContent";

import { css } from "@oddcommon/utils";
import styles from "./TextBlock.module.scss";

export default function TextBlock({ label, children, layout }) {
  return (
    <div className={styles.base}>
      <LabeledContent label={label} className={css(styles.container, styles[`layout-${layout}`])}>
        <div className={styles.content}>{children}</div>
      </LabeledContent>
    </div>
  );
}

TextBlock.propTypes = {
  label: PropTypes.node,
  children: PropTypes.node.isRequired,
  layout: PropTypes.oneOf(["left", "right", "center", "left-center", "right-center"]),
};
TextBlock.defaultProps = {
  layout: "left",
};
